module.exports = __webpack_public_path__ + "img/totalSales.c0ac4c87.svg";